<template>
  <div class="out">
    <div class="page-title">
      <div class="container">
        <b-jumbotron
          :header="header"
          style="color:white;background-color: rgba(0, 0, 0, 0);width:80%"
        >
          <h1>小微企业SaaS管理云</h1>
          <hr class="my-4">
          <p>业财税一体化解决方案, 助力小微企业智慧成长</p>
        </b-jumbotron>
      </div>
    </div>
    <div class="title">
      <div style="display:flex;padding-top:100px;padding-bottom:100px;flex-direction: column">
        <p style="font-weight: 600;font-size:30px">金蝶云·星辰能帮您做什么?</p>
        <p style="font-weight: 600;">金蝶云·星辰基于金蝶云·苍穹云原生PaaS平台构建，聚焦小微企业在线经营和数字化管理</p>
        <p style="font-weight: 600;">提供财务云、税务云、进销存云、零售云、订货商城等SaaS服务，支持企业拓客开源、智能管理、实时决策</p>
        <p style="font-weight: 600;">金蝶云·星辰还提供轻量级PaaS平台和全面的API接口，广泛连接生态伙伴，为小微企业提供一站式服务，助力企业快速成长</p>
        <!-- <img src="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202108/26150238x63u.png"> -->
        <video width="1080" height="720" style="margin:auto" controls>
          <source src="https://1252177366.vod2.myqcloud.com/202165b2vodtranscq1252177366/af5553945285890811947074971/v.f100800.mp4" poster="https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202108/26150238x63u.png" type="video/mp4">
        </video>
      </div>
    </div>
    <div style="background:rgb(242 246 250)">
      <div class="title">
        <div style="display:flex;padding-top:100px;padding-bottom:100px">
          <img src="./xc3.png">
        </div>
      </div>
    </div>
    <div class="title">
      <div style="display:flex;padding-top:100px;padding-bottom:100px">
        <img src="./xc2.png">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Cosmic',
  data() {
    return {
      header: '金蝶云 · 星辰',
      leader: '面向大企业、央国企的数字化转型SaaS解决方案，助力大企业实现转型升级和创新发展'
    }
  },

  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.out{
  display: inline-block;
  vertical-align:top;
  width:100%;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.page-title {
  background: url('https://kingdeecms-1252177366.cos.ap-guangzhou.myqcloud.com/u/cms/www/202109/02164523c99s.jpg') no-repeat;
  background-size: 100% 100%;
  height: 500px;
  text-align: left;
  padding-top: 60px;
  padding-bottom: 2px;
  /* max-width: 1200px; */
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
</style>>



// WEBPACK FOOTER //
// src/components/kingdeestar.vue